export const ACCOUNT_LOGIN_TOKEN_CREATED = '@ZAPI_ACCOUNT_LOGIN_TOKEN_CREATED';
export const ACCOUNT_V3_LOGGED_IN = '@ZAPI_ACCOUNT_V3_LOGGED_IN';
export const ACCOUNT_V3_LOGGED_OUT = '@ZAPI_ACCOUNT_V3_LOGGED_OUT';
export const ACCOUNT_V3_OAUTH_LOGGED_IN = '@ZAPI_ACCOUNT_V3_OAUTH_LOGGED_IN';
export const ACCOUNT_V3_SSO_LOGGED_IN = '@ZAPI_ACCOUNT_V3_SSO_LOGGED_IN';

export const ACCOUNT_DELETED = '@ZAPI_ACCOUNT_DELETED';
export const ACCOUNT_PROFILE_RECEIVED = '@ZAPI_ACCOUNT_PROFILE_RECEIVED';
export const ACCOUNT_UPDATED = '@ZAPI_ACCOUNT_UPDATED';
export const API_SIGNATURE_RECEIVED = '@ZAPI_ACCOUNT_API_SIGNATURE_RECEIVED';
export const CREDIT_CARD_EXPIRATION_UPDATED = '@ZAPI_ACCOUNT_CREDIT_CARD_EXPIRATION_UPDATED';

export const OAUTH_CODE_REQUESTED = '@ZAPI_OAUTH_CODE_REQUESTED';
export const PASSWORD_CHANGED = '@ZAPI_ACCOUNT_PASSWORD_CHANGED';
export const PASSWORD_RESET_REQUESTED = '@ZAPI_ACCOUNT_PASSWORD_RESET_REQUESTED';
export const PAYMENT_METHODS_RECEIVED = '@ZAPI_ACCOUNT_PAYMENT_METHODS_RECEIVED';
export const PAYMENT_METHOD_UPDATED = '@ZAPI_ACCOUNT_PAYMENT_METHOD_UPDATED';
export const PAYMENT_METHOD_REMOVED = '@ZAPI_ACCOUNT_PAYMENT_METHOD_REMOVED';
export const PRIVACY_SETTING_ADDED = '@ZAPI_ACCOUNT_PRIVACY_SETTING_ADDED';
export const PRIVACY_SETTING_REMOVED = '@ZAPI_ACCOUNT_PRIVACY_SETTING_REMOVED';
export const TRANSACTIONS_RECEIVED = '@ZAPI_ACCOUNT_TRANSACTIONS_RECEIVED';
export const BILLING_ADDRESS_RECEIVED = '@ZAPI_ACCOUNT_BILLING_ADDRESS_RECEIVED';
export const BILLING_ADDRESS_UPDATED = '@ZAPI_ACCOUNT_BILLING_ADDRESS_UPDATED';
export const SUBSCRIBE_REQUESTED = '@ZAPI_ACCOUNT_SUBSCRIBE_REQUESTED';
export const AUTORENEW_UPDATED = '@ZAPI_ACCOUNT_AUTORENEW_UPDATED';
export const AUTORENEW_CANCELED = '@ZAPI_ACCOUNT_AUTORENEW_CANCELED';
export const PIN_RECEIVED = '@ZAPI_ACCOUNT_PIN_RECEIVED';
export const PIN_UPDATED = '@ZAPI_ACCOUNT_PIN_UPDATED';
export const PIN_STATE_RECEIVED = '@ZAPI_ACCOUNT_PIN_STATE_RECEIVED';
export const PIN_STATE_UPDATED = '@ZAPI_ACCOUNT_PIN_STATE_UPDATED';
export const REPLAY_SETTING_UPDATED = '@ZAPI_REPLAY_SETTING_UPDATED';
export const NEWSLETTER_UNSUBSCRIBE = '@ZAPI_NEWSLETTER_UNSUBSCRIBE';
export const LOGIN_TOKEN_OBTAINED = '@ZAPI_LOGIN_TOKEN_OBTAINED';
export const LOGIN_TOKEN_VERIFIED = '@ZAPI_LOGIN_TOKEN_VERIFIED';

/** @deprecated - use ACCOUNT_V3_CREATED */
export const ACCOUNT_CREATED = '@ZAPI_ACCOUNT_CREATED';

/** @deprecated - use ACCOUNT_V3_LOGGED_IN */
export const LOGGED_IN = '@ZAPI_LOGGED_IN';

/** @deprecated - use ACCOUNT_V3_LOGGED_OUT */
export const LOGGED_OUT = '@ZAPI_ACCOUNT_LOGGED_OUT';

/** @deprecated - use ACCOUNT_V3_OAUTH_LOGGED_IN */
export const OAUTH_LOGGED_IN = '@ZAPI_ACCOUNT_OAUTH_LOGGED_IN';

/** @deprecated - use ACCOUNT_V3_SSO_LOGGED_IN */
export const SSO_LOGGED_IN = '@ZAPI_ACCOUNT_SSO_LOGGED_IN';
